import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
export default function NotFound() {
  const { i18n } = useTranslation();
  const en = i18n.language.startsWith('en');
  return <main className="not-found">
    <span className="eyebrow">404</span>
    <h1>{en ? 'Page not found' : 'Sidan kunde inte hittas'}</h1>
    <p>{en ? 'The link may have changed. Explore our services or tell us about your project.' : 'Länken kan ha ändrats. Utforska våra tjänster eller berätta om ditt projekt.'}</p>
    <Link className="site-button" to="/">{en ? 'Back to home' : 'Till startsidan'}</Link>
    <Link className="text-link" to="/#contact">{en ? 'Contact us' : 'Kontakta oss'}</Link>
  </main>;
}
